import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Services from '@/views/Services'
import Assistant from '@/views/Services/Assistant.vue'
import Mining from '@/views/Services/Mining.vue'
import Automation from '@/views/Services/Automation.vue'
import IA from '@/views/Services/IA.vue'
import Testimonials from '@/views/Testimonials'
import Contact from '@/views/Contact'
import Terms from '@/views/Terms'
import Error404 from '@/views/Error404'


Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            color: 'light',
            title: 'Grow faster with Zeal Agency',
            description: 'Boost your business growth and breathe easier with our outsourcing and automation services.',
            robots: 'index, follow',
            canonical: 'https://zealagency.co',
            scroll: false
        }
    },
    {
        path: '/services/',
        name: 'services',
        component: Services,
        redirect: '/services/virtual-assistant-for-hire',
        meta: {
            color: 'dark',
            title: 'Zeal Agency - Services',
            description: '',
            robots: 'index, follow',
            canonical: 'https://zealagency.co/services/virtual-assistant-for-hire',
            scroll: false
        },
        children: [
            {
                name: 'assistant',
                path: 'virtual-assistant-for-hire',
                component: Assistant,
                meta: {
                    color: 'dark',
                    title: 'Hire a zealous virtual assistant | Zeal Agency',
                    description: 'Free up your time to focus on the tasks that move the needle and drive growth, with the help of our adept VA service.',
                    robots: 'index, follow',
                    canonical: 'https://zealagency.co/services/virtual-assistant-for-hire',
                    scroll: false
                }
            },
            {
                name: 'mining',
                path: 'web-scraping',
                component: Mining,
                meta: {
                    color: 'dark',
                    title: 'Get data through mining and scraping | Zeal Agency',
                    description: 'Understand your audience or competitors by quickly gathering information from the web with our data mining services.',
                    robots: 'index, follow',
                    canonical: 'https://zealagency.co/services/web-scraping',
                    scroll: false
                }
            },
            {
                name: 'automation',
                path: 'business-process-automation',
                component: Automation,
                meta: {
                    color: 'dark',
                    title: 'Automate your growth | Zeal Agency',
                    description: 'Automate repetitive tasks and processes to manage your time better and invest it where it matters most.',
                    robots: 'index, follow',
                    canonical: 'https://zealagency.co/services/business-process-automation',
                    scroll: false
                }
            },
            {
                name: 'ia',
                path: 'business-intelligence',
                component: IA,
                meta: {
                    color: 'dark',
                    title: 'Insights to boost your business | Zeal Agency',
                    description: 'We gather important insights about your business to provide you help you make better decisions.',
                    robots: 'index, follow',
                    canonical: 'https://zealagency.co/services/business-intelligence',
                    scroll: false
                }
            }
        ]
    },
    {
        path: '/our-happy-clients',
        name: 'testimonials',
        component: Testimonials,
        meta: {
            color: 'light',
            title: 'Words from our happy clients | Zeal Agency',
            description: 'Don\'t take it from us. See why our clients decide to stick with our services.',
            robots: 'index, follow',
            canonical: 'https://zealagency.co/our-happy-clients',
            scroll: false
        }
    },
    {
        path: '/work-with-us',
        name: 'contact',
        component: Contact,
        meta: {
            color: 'blue',
            title: 'Contact us and let\'s grow together | Zeal Agency',
            description: 'Leave us a message or schedule a call to see how we can help you grow your business today.',
            robots: 'index, follow',
            canonical: 'https://zealagency.co/work-with-us',
            scroll: false
        }
    },
    {
        path: '/terms-of-use',
        name: 'terms',
        component: Terms,
        meta: {
            color: 'light',
            title: 'Terms of use | Zeal Agency',
            description: '',
            robots: 'noindex, nofollow',
            canonical: 'https://zealagency.co/terms-of-use',
            scroll: true
        }
    },
    {
        path: '*',
        name: '404',
        component: Error404,
        meta: {
            color: 'light',
            title: 'Zeal Agency - Page not found',
            description: '',
            robots: 'noindex, nofollow',
            scroll: false
        }
    }
]

const router = new Router({
    routes,
    mode: 'history',
    base: process.env.BASE_URL
})

export { routes, router }
